import { Router, Routes } from '@angular/router';
import { LayoutComponent } from './layouts/layout/layout.component';
import { AuthLayoutComponent } from '@layouts/auth-layout/auth-layout.component';
import { inject } from '@angular/core';
import { AuthenticationService } from '@core/services/auth.service';
import { HorizontalLayoutComponent } from '@layouts/horizontal-layout/horizontal-layout.component';
import { MainLayoutComponent } from '@layouts/main-layout/main-layout.component';

// Application routes configuration
export const routes: Routes = [
  {
    path: 'share',
    loadComponent: () =>
      import('./views/public/share/share.component').then(
        (mod) => mod.ShareComponent
      ),
    // No authentication required - public route
  },
  {
    path: '',
    redirectTo: '/pages/dashboard',
    pathMatch: 'full',
  },
  {
    path: 'health-check',
    component: LayoutComponent,
    loadChildren: () =>
      import('./views/health-check/health-check.routes').then(
        (mod) => mod.HEALTH_CHECK_ROUTES,
      ),
    canActivate: [
      (url: any) => {
        const router = inject(Router);
        const authService = inject(AuthenticationService);
        if (!authService.session) {
          return router.createUrlTree(['/auth/login'], {
            queryParams: { returnUrl: url._routerState.url },
          });
        }
        return true;
      },
    ],
  },

  {
    path: '',
    component: LayoutComponent,
    loadChildren: () =>
      import('./views/views.route').then((mod) => mod.VIEWS_ROUTES),
    canActivate: [
      (url: any) => {
        const router = inject(Router);
        const authService = inject(AuthenticationService);
        if (!authService.session) {
          return router.createUrlTree(['/auth/login'], {
            queryParams: { returnUrl: url._routerState.url },
          });
        }
        return true;
      },
    ],
  },

  {
    path: '',
    loadChildren: () =>
      import('./views/other-pages/other-page.route').then(
        (mod) => mod.OTHER_ROUTES,
      ),
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./views/auth/auth.route').then((mod) => mod.AUTH_ROUTES),
  },
  {
    path: '',
    component: MainLayoutComponent,
    loadChildren: () =>
      import('./views/layout-pages/layout.route').then(
        (mod) => mod.LAYOUT_ROUTES,
      ),
  },
  {
    path: '',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./views/error-pages/error-pages.route').then(
        (mod) => mod.ERROR_PAGES_ROUTES,
      ),
  },
  {
    path: '',
    component: HorizontalLayoutComponent,
    loadChildren: () =>
      import('./views/layout-pages/horizontal/detached.route').then(
        (mod) => mod.HORIZONTAL_ROUTE,
      ),
  },
  {
    path: '**',
    canActivate: [
      (url: any) => {
        const router = inject(Router);
        const authService = inject(AuthenticationService);
        if (authService.session) {
          return router.createUrlTree(['/pages/error-404-alt'], {
            queryParams: { returnUrl: url._routerState.url },
          });
        } else {
          return router.createUrlTree(['/error-404'], {
            queryParams: { returnUrl: url._routerState.url },
          });
        }
      },
    ],
    loadComponent: () =>
      import('./views/pages/error-two-404/error-two-404.component').then(
        (mod) => mod.ErrorTwo404Component,
      ),
  },
];
